import { Chip } from "@mui/material";
import { GridApiPremium } from "@mui/x-data-grid-premium/models/gridApiPremium";
import { MutableRefObject, memo } from "react";

import CommonTableToolbar from "@/components/CommonTableToolbar";
import { LocaleStorageKeys } from "@/constants";
import {
    useClinicArrivalTasksGridActions,
    useClinicArrivalTasksIsFullScreen,
} from "@/stores/use-clinic-arrival-tasks-grid";
import { CommonStatusItem } from "@/types/global";

import { HotelClinicTaskResolved } from "../../types";
import HotelClinicArrivalSectionTooltip from "../HotelClinicArrivalSectionTitle";
import ClinicArrivalTasksChangesButton from "./ClinicArrivalTasksChangesButton";
import { defaultTasksTableGridOptions } from "./defaultTasksTableGridOptions";

const TasksTableToolbar = memo(function TasksTableToolbar({
    apiRef,
    rows,
    ...commonStatusProps
}: {
    apiRef: MutableRefObject<GridApiPremium>;
    allRows: HotelClinicTaskResolved[];
    rows: HotelClinicTaskResolved[];
} & CommonStatusItem) {
    const isFullScreen = useClinicArrivalTasksIsFullScreen();
    const { updateFullScreen } = useClinicArrivalTasksGridActions();

    return (
        <CommonTableToolbar
            apiRef={apiRef}
            isFullScreen={isFullScreen}
            onFullScreenToggle={() => updateFullScreen()}
            storageKey={LocaleStorageKeys.CLINIC_ARRIVAL_TASKS_GRID_SETTINGS}
            defaultOptions={defaultTasksTableGridOptions}
            hideQuickFilter
            TitleComponent={
                <>
                    <HotelClinicArrivalSectionTooltip label="Görevler" {...commonStatusProps} />
                    <Chip
                        sx={{
                            backgroundColor: commonStatusProps.bg,
                            color: commonStatusProps.text,
                            fontWeight: 500,
                            fontSize: "12px !important",
                        }}
                        size="small"
                        className="ml-1"
                        label={rows.length + " " + "Görev"}
                    />
                </>
            }
        >
            <ClinicArrivalTasksChangesButton apiRef={apiRef} />
        </CommonTableToolbar>
    );
});

export default TasksTableToolbar;
